// Cancel.jsx - 無料版専用安全版（プレミアム要素完全削除）

import React from 'react';

const Cancel = () => {
  // プレミアム機能は一時的に完全無効化
  const PREMIUM_FEATURES_ENABLED = false;

  const handleReturnToApp = () => {
    // アプリのメイン画面に戻る
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6">
        <div className="text-center">
          {/* ヘッダー */}
          <div className="mb-6">
            <div className="mx-auto w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-4">
              <span className="text-2xl">⏸️</span>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              操作をキャンセルしました
            </h1>
            <p className="text-gray-600">
              何も変更されませんでした
            </p>
          </div>

          {/* 現在の状態説明 */}
          <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <h2 className="font-semibold text-blue-800 mb-2">
              現在のプラン: 無料プラン
            </h2>
            <div className="text-sm text-blue-700 space-y-1">
              <div className="flex items-center justify-center">
                <span className="text-green-600">✅</span>
                <span className="ml-2">1日3回のAI投稿生成</span>
              </div>
              <div className="flex items-center justify-center">
                <span className="text-green-600">✅</span>
                <span className="ml-2">高品質AI生成機能</span>
              </div>
              <div className="flex items-center justify-center">
                <span className="text-green-600">✅</span>
                <span className="ml-2">APIキー設定不要</span>
              </div>
            </div>
          </div>

          {/* 無料版継続利用の案内 */}
          <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
            <h3 className="font-semibold text-green-800 mb-2">
              📱 無料版を活用しましょう
            </h3>
            <p className="text-sm text-green-700">
              無料版でも十分に高品質なAI投稿生成をお楽しみいただけます。<br />
              設定不要で今すぐご利用できます。
            </p>
          </div>

          {/* 今後の機能開発について */}
          {!PREMIUM_FEATURES_ENABLED && (
            <div className="mb-6 p-4 bg-gray-50 border border-gray-200 rounded-lg">
              <div className="flex items-center justify-center mb-2">
                <span className="text-gray-600">🚧</span>
                <span className="ml-2 text-sm text-gray-700 font-medium">
                  追加機能開発中
                </span>
              </div>
              <p className="text-xs text-gray-600">
                より便利な機能を開発中です。<br />
                リリースまでしばらくお待ちください。
              </p>
            </div>
          )}

          {/* アクションボタン */}
          <div className="space-y-3">
            <button
              onClick={handleReturnToApp}
              className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-blue-700 transition-colors"
            >
              アプリに戻って投稿生成する
            </button>
            
            <div className="text-center">
              <p className="text-xs text-gray-500">
                無料版で1日3回まで高品質なAI投稿が生成できます
              </p>
            </div>
          </div>

          {/* サポート情報 */}
          <div className="mt-6 pt-4 border-t border-gray-200">
            <p className="text-xs text-gray-500">
              ご質問がございましたら<br />
              <a href="mailto:numaken@gmail.com" className="text-blue-600 hover:underline">
                numaken@gmail.com
              </a>
              までお気軽にお問い合わせください
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cancel;
